<script>
  import { onMount } from "svelte";
  import DescriptionBox from "../UI/DescriptionBox.svelte";

  export let contentData = null;

  let exeData = null;

  onMount(() => {
    exeData = contentData;
  });
</script>

<div class="wrapper">
  <svelte:component this={exeData?.src} />
  {#if exeData?.description}
    <DescriptionBox>
      {exeData?.description}
    </DescriptionBox>
  {:else}
    <DescriptionBox />
  {/if}
</div>

<style>
  .wrapper {
    height: 100%;
    overflow: hidden;
    position: relative;
  }
</style>
